import { createTheme } from '@mui/material/styles';
import { PolcoColor } from './colors-class';

export const theme = createTheme({
  palette: {
    primary: { main: new PolcoColor('Jungle').hex },
  },
  typography: {
    h1: {
      fontSize: '2.5rem',
      fontWeight: 400,
      lineHeight: '3rem',
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 400,
      lineHeight: '2.5rem',
    },
    h3: {
      fontSize: '1.5rem',
      fontWeight: 400,
      lineHeight: '2rem',
    },
    h4: {
      fontSize: '1.25rem',
      fontWeight: 400,
      lineHeight: '1.75rem',
    },
    h5: {
      fontSize: '1.125rem',
      fontWeight: 400,
      lineHeight: '1.625rem',
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 400,
      lineHeight: '1.5rem',
    },
    body1: {
      fontSize: '1rem',
      fontWeight: 400,
      lineHeight: '1.5rem',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
});
